import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';

import { BaseballCard } from '@minecraft.molecules';
import { TalentScoutProfileFragment } from '@minecraft.graphql-operations';

import { ContactTalent } from './ContactTalent';
import { PitchNotes } from './PitchNotes';
import { Profile } from './Profile';
import { SeekingRepresentation } from './SeekingRepresentation';
import { SpiceRack } from './SpiceRack';

const MainPanel = ({
  profile,
  displaySocialMediaSection,
}: {
  profile: TalentScoutProfileFragment;
  displaySocialMediaSection: boolean;
}) => {
  return (
    <BaseballCard.DividedSection data-testid="talentscout-profile-main">
      <Profile profile={profile} displaySocialMediaSection={displaySocialMediaSection} />
      <SpiceRack {...profile} />
      <ContactTalent {...profile} />
    </BaseballCard.DividedSection>
  );
};

const SidePanel = (profile: TalentScoutProfileFragment) => {
  return (
    <BaseballCard.DividedSection data-testid="talentscout-profile-side">
      <BaseballCard.Section size="small" gap="2">
        <PitchNotes {...profile} />
        <SeekingRepresentation {...profile} />
      </BaseballCard.Section>
    </BaseballCard.DividedSection>
  );
};

type TalentCardViewProps = {
  loading?: boolean;
  profiles?: TalentScoutProfileFragment[];
  showPitchNotesAndRepTypeInfo?: boolean;
  displaySocialMediaSection?: boolean;
};

export const TalentCardView = ({
  loading = false,
  profiles = [],
  showPitchNotesAndRepTypeInfo = false,
  displaySocialMediaSection = false,
  ...props
}: TalentCardViewProps) => {
  return (
    <div {...props}>
      <BaseballCard.Grid
        className="cn_w-full"
        data-testid="talentscout-profile-grid"
        numberOfDividedSections={showPitchNotesAndRepTypeInfo && !loading ? 2 : 1}
      >
        {loading ? (
          <BaseballCard.LoadingBaseballCards count={24} />
        ) : (
          profiles.map((profile, idx) => (
            <BaseballCard.Base
              data-testid={`talentscout-profile-card-${profile.id}`}
              key={profile.id || `bb-card-base-${idx}`}
            >
              <MainPanel profile={profile} displaySocialMediaSection={displaySocialMediaSection} />
              {showPitchNotesAndRepTypeInfo && <SidePanel {...profile} />}
            </BaseballCard.Base>
          ))
        )}
      </BaseballCard.Grid>
    </div>
  );
};
